/**
 * Joins the user and the account in an owner-page Wix user's reply name
 * ("<user> @ <account>"). Shared by the BFF that builds it and the client
 * that seeds the avatar from the user part.
 */
export const WIX_USER_NAME_SEPARATOR = ' @ ';
